module.exports = __webpack_public_path__ + "oktaVerify_ico@1x.b6ed695e6f2adcf531a5fc2d4d94cbc8.png";